/**
 * The three published tutorials on creating and using a dashboard.
 * Shown beside the empty-dashboard prompt.
 */

import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { getTutorials } from 'src/features/tutorials/redux';
import HelpLinkList from './HelpLinkList';
import { dashboardTutorialLinks, type CatalogueTutorial } from './links';

interface DashboardCreateLinksProps {
  className?: string;
}

export default function DashboardCreateLinks({ className }: DashboardCreateLinksProps) {
  const dispatch = useAppDispatch();
  const tutorials = useAppSelector((state) => (state.tutorials.tutorials ?? []) as CatalogueTutorial[]);

  useEffect(() => {
    void dispatch(getTutorials());
  }, [dispatch]);

  const links = useMemo(() => dashboardTutorialLinks(tutorials), [tutorials]);

  return <HelpLinkList links={links} className={className} heading="Tutorials" />;
}
